import React from 'react'

import { setMeetingSummaryExportingToPDF } from '../../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { selectRoomSession } from '../../../../../../../store/meetingSummary/roomSession'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'

import { useExportConfirmation } from '../../../../../../../components/ConfirmationDialog/useExportConfirmation'
import { Button } from '../../../../../../../components/Button/Button'

export const MeetingSummaryAgentPDFButton = () => {
  const dispatch = useAppDispatch()

  const roomSession = useAppSelector(selectRoomSession)

  const { runMutationWithConfirmation, ConfirmationModal, accountIsLoading } = useExportConfirmation({ roomSession, exportType: 'document' })

  const handleClick = async () => {
    await runMutationWithConfirmation(async () => dispatch(setMeetingSummaryExportingToPDF(true)))
  }

  return (
    <>
      <ConfirmationModal />
      <Button className='px-2 py-1 button-medium' variant='header' onClick={handleClick} disabled={accountIsLoading}>
        <i className='bi bi-file-pdf' /> Export to PDF
      </Button>
    </>
  )
}
